import React, { Component } from 'react';
import { ScrollView, View, Dimensions, StyleSheet } from 'react-native';
var { width, height } = Dimensions.get('window');// You can import from local files
import { Text, Avatar } from 'react-native-elements';
import { DataCall } from "./utils/DataCall";
import { Card, Button, Appbar, Searchbar, ActivityIndicator, Colors } from 'react-native-paper';
import Moment from 'moment';

class Tab extends Component {
    constructor(props) {
        super(props);
    }

    static navigationOptions = {
        header: null
    };

    render() {
        return <><Appbar.Header>
        <Appbar.Content title="About Munishri Pranamya Sagar ji" />
    </Appbar.Header>
    <ScrollView style={{flex: 1, padding: 10}}>
        <Text h3>मुनि श्री प्रणम्य सागर जी महाराज</Text>
<Text>पूर्व नाम : ब्र. सर्वेश जी</Text>
<Text>पिता-माता : श्री वीरेन्द्र कुमार जी जैन एवं श्रीमती सरिता देवी जैन</Text>
<Text>जन्म : 13.09.1975, भाद्रपद शुक्ल अष्टमी </Text>
<Text>जन्म स्थान : भोगांव, जिला मैनपुरी (उत्तर प्रदेश)</Text>
<Text>वर्तमान में : सिरसागंज, फिरोजाबाद (उत्तर प्रदेश)</Text>
<Text>शिक्षा : बीएससी (अंग्रेजी माध्यम)</Text>
<Text>भाई : सचिन जैन</Text>
<Text>बहिन : सपना जैन</Text>
<Text>गृह त्याग : 09.08.1994</Text>
<Text>क्षुल्लक दीक्षा : 09.08.1997, नेमावर</Text>
<Text>एलक दीक्षा : 05.01.1998, नेमावर</Text>
<Text>मुनि दीक्षा : 11.02.1998, माघ सुदी 15, बुधवार, मुक्तागिरीजी</Text>
<Text>दीक्षा गुरु : आचार्य श्री विद्यासागर जी महाराज</Text>
<Text style={{marginTop: 25}}>
पूज्यास्पद मुनिश्री १०८ प्रणम्य सागर जी महाराज श्रमण साधुओं की वंदनीय परम्परा में महनीय स्थान के अधिकारी पुण्य पुरुष हैं| आपके महान परिचय को लेखनी से लिख पाना अत्यंत दुर्द्धर है| पहाड़ को काटकर सुरंग निकाली जा सकती है, धरती को चीर कर पानी निकाला जा सकता है, आसमां को फाड़कर धरती पर भागीरथी को धरती पर लाया जा सकता है लेकिन आपके जैसे गुरु की महिमा का वर्णन संभव नही|
</Text>
<Text style={{marginTop: 25}}>
आप एक नहीं अनेक गुणों के धारी हैं, आप एक नहीं अनेक सलाह व सुराह के दर्शायक हैं, चतुर्थ काल सम आपकी चर्या है, आप वात्सल्य के सागर हैं, आपके मुख पर मंद मधुर मुस्कान प्रतिपल रहती है, आपकी मृदु वाणी जनकल्याणी है| यह आपकी वाणी का ही जादू है कि प्रवचनसार जैसे महान ग्रन्थ पर आपके प्रवचनों का ध्याय पारस, जिनवाणी एवं यूट्यूब जैसे चैनलों के माध्यम से विश्व भर में सुने गये|
</Text>
<Text style={{marginTop: 25}}>
आपके तपोनिष्ठ जीवन का एकमात्र ध्येय सम्यक ज्ञान के साथ एकान्त श्रुतोपासना है| श्रुतोपासना की निरंतरता के क्रम में आपके द्वारा महान ग्रंथो की रचना हुई है| यह आपकी लेखनी का ही जादू है कि प्राकृत भाषा जो कि हमारे आगम की भाषा है जिसे आज लोग भूल गए थे इसे भी “पाइय-सिक्खा” पुस्तक श्रृंखला की रचना से इतना सरल बना दिया कि जन जन में प्राकृत सीखने की लहर उठ गयी है आपके द्वारा रचित “पाइय-सिक्खा” पुस्तक इतनी सरल हैं जिसे आज 5 वर्ष से लेकर 70 वर्ष तक के वृद्ध, युवा महिलाएं एवं बच्चे पढ़ रहें हैं|
</Text>
<Text style={{marginTop: 25}}>
<Text h4>प्राकृत पाठशालाएं: </Text>
</Text>
<Text>
आपके आशीर्वाद से विभिन्न स्थानों पर अपनी संस्कृति एवं भाषा के संरक्षण हेतु प्राकृत की पाठशालाएं सुचारू रूप से चल रहीं हैं| आज प्राकृत ऑनलाइन पाठशालाओं के माध्यम से भी लोग घर बैठे ही लोग “पाइय-सिक्खा” की पुस्तकों से प्राकृत का ज्ञान अर्जित कर रहें हैं| आपने जहाँ एक और प्राकृत से परिचय कराया है वहीँ दूसरी ओर अर्हं ध्यान के माध्यम से हमारी प्राचीन सभ्यता को जीवित किया है| अर्हं ध्यान आज सभी के लिए वरदान सिद्ध हुआ है| जनसाधारण को अर्हं ध्यान के मध्यं से असाध्य रोगों से मुक्ति मिल रही है| आजकी युवा पीढ़ी को सुदृढ़ बनाने के लिए Life Management, Fact of Fate, लक्ष्य, जिन्दगी क्या है जैसी पुस्तकों को लिखकर बच्चो एवं युवाओं को एक सकारात्मक दिशा दी है|
</Text>

<Text style={{marginTop: 25}}>
<Text h4>अकलंक शरणालय छात्रावास: </Text>

बच्चो को संस्कारों से सज्जित, नवीन एवं सकारात्मक दिशा प्राप्त हो इस हेतु आपकी पावन प्रेरणा एवं मंगल आशीर्वाद से रेवाड़ी में “अकलंक शरणालय छात्रावास” की स्थापना हुई है| यहाँ बच्चे उच्च सिक्षा के साथ धर्म की शिक्षा भी ग्रहण कर रहें हैं| 
</Text>
<Text style={{marginTop: 25}}>

<Text h4>कृतियाँ: </Text>

आपने चाहे प्राकृत हो संस्कृत हो अथवा अंग्रेजी सभी भाषाओं में अनुपम एवं अद्वितीय कृतियों की रचना की है| प्रतिक्रमण ग्रंथत्रयी, दार्शनिक प्रतिक्रमण, तिथ्यर भावणा, बरसाणु पेक्खा (कादम्बनी टीका), स्तुति पथ, प्रश्नोत्तर रत्नमालिका, अर्चना पथ, पाइए सिक्खा, अनासक्त महायोगी, श्री वर्धमान स्त्रोत, अर्न्तगूंज बेटा, नयी छहढाला, जैन सम्राट चन्द्रगुप्त मौर्य, मनोविज्ञान, लोक विज्ञान, Fact of Fate, Talk for Learners आदि 80 से भी अधिक कृतियों की रचना की है|
</Text>
<Text style={{marginTop: 25}}>

source:https://www.pranamyasagar.org/index.php/about-us
        </Text>
        <Text h5>This App is Developed by: Siddharth Sogani</Text>
    </ScrollView></>
    }
}

const styles = StyleSheet.create({
    loadingView: {
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1
    },
    loadingText: {
        color: '#2196f3',
        fontSize: 14,
        fontWeight: 'bold'
    }
});

export default Tab
